import { useEffect } from 'react';
import Input from '../../../ui/input';
import Switch from '../../../ui/switch';
import Text from '../../../ui/text';
import { useFormContext } from "react-hook-form";

function MailAddressInfo() {
  const { 
    watch,
    register,
    resetField,
    control,
    formState: { errors },
  } = useFormContext();
  const watchDifferentMailingAddress = watch('differentMailingAddress');

  useEffect(() => {
    if (!watchDifferentMailingAddress) {
      resetField('mailAddressLine1');
      resetField('mailAddressLine2');
      resetField('mailState');
      resetField('mailCity');
      resetField('mailZipCode');
    }
  }, [watchDifferentMailingAddress]);
  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold leading-none opacity-[var(--sds-size-stroke-border)] text-sky-950">
        <Text>Mailing Address</Text>
      </h2>
      <p className="text-base leading-10 text-zinc-600 max-md:max-w-full">
        <Text>(PO Box is allowed)</Text>
      </p>
      <div className='w-full flex flex-col justify-start items-start mt-5'>
        <Switch name='differentMailingAddress' control={control}>
          <Text>Different Mailing Address?</Text>
        </Switch>
      </div>
      {watchDifferentMailingAddress && (
        <div className="grid grid-cols-12 gap-5 mt-5">
          <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='mailAddressLine1'>Permanent Address (Line 1)</Text>
            <Input
              {...register('mailAddressLine1')}
              size='sm'
              label={<Text>Permanent Address (Line 1)</Text>}
              placeholder="-"
              errorMessage={errors?.mailAddressLine1?.message || null}
              isInvalid={errors?.mailAddressLine1 ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='mailAddressLine2'>Address (Line 2)</Text>
            <Input
              {...register('mailAddressLine2')}
              size='sm'
              label={<Text>Last Name</Text>}
              placeholder="-"
              errorMessage={errors?.mailAddressLine2?.message || null}
              isInvalid={errors?.mailAddressLine2 ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='mailCity'>City</Text>
            <Input
              {...register('mailCity')}
              size='sm'
              label={<Text>City</Text>}
              placeholder="-"
              errorMessage={errors?.mailCity?.message || null}
              isInvalid={errors?.mailCity ? true : false}
            />
          </div>
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='mailState'>State</Text>
            <Input
              {...register('mailState')}
              size='sm'
              label={<Text>State</Text>}
              placeholder="-"
              errorMessage={errors?.mailState?.message || null}
              isInvalid={errors?.mailState ? true : false}
            />
          </div> 
          <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
            <Text type='label' htmlFor='mailZipCode'>ZIP Code</Text>
            <Input
              {...register('mailZipCode')}
              size='sm'
              label={<Text>ZIP Code</Text>}
              placeholder="-"
              errorMessage={errors?.mailZipCode?.message || null}
              isInvalid={errors?.mailZipCode ? true : false}
            />
          </div>
      </div>
    )}
    </section>
  );
}

export default MailAddressInfo;